import TextInput from "../../../components/TextInput/TextInput";
import SelectInput from "../../../components/SelectInput/SelectInput";
import FieldLabel from "../../../components/FieldLabel/FieldLabel";
import { CLINICAL_PURPOSE_OPTIONS } from "../../../utils/surveysConstants";

const SurveyDetailsFields = ({ formData, errors, onChange }) => {
  return (
    <div className="survey-details-card">
      <div className="survey-details-row">
        <div className="survey-details-col">
          <TextInput
            title="Study / Program Name"
            name="studyName"
            value={formData.studyName}
            onChange={onChange}
            placeholder="e.g. WeBe Participant Study"
          />
        </div>
        <div className="survey-details-col">
          <div className="survey-version-field">
            <FieldLabel>Survey Version</FieldLabel>
            <div className="survey-version-display">
              <span className="survey-version-text">
                v{formData.version || "1"}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="survey-details-field">
        <TextInput
          title="Survey Title*"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter survey title"
        />
        <span className="error">{errors.title}</span>
      </div>

      <div className="survey-details-field">
        <TextInput
          title="Participant Instructions"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Please answer the following questions based on how you feel today."
          multiline
          rows={3}
        />
      </div>

      <div className="survey-details-row">
        <div className="survey-details-col" style={{ maxWidth: "280px" }}>
          <SelectInput
            title="Clinical Purpose"
            name="clinicalPurpose"
            value={formData.clinicalPurpose}
            onChange={onChange}
            options={CLINICAL_PURPOSE_OPTIONS}
            placeholder="Select purpose"
          />
        </div>
      </div>
    </div>
  );
};

export default SurveyDetailsFields;
